
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Diagram } from '@clients/bff';
import StatisticEntryView from './StatisticEntryView.vue';
import StatisticAttribute from '../../models/statistic/StatisticAttribute';
import { namespace } from 'vuex-class';
import { isNullOrUndefined } from 'util';

const StatisticModule = namespace('Statistic');
const TriplogModule = namespace('Triplog');

@Component({
  name: 'DiagramView',
  components: {
    StatisticEntryView,
  },
})
export default class DiagramView extends Vue {
  @Prop()
  private diagram: Diagram;

  @Prop()
  private index: number;

  @StatisticModule.Getter('getDiagramSelections')
  private diagramSelections: StatisticAttribute[];

  @StatisticModule.Mutation('SET_DIAGRAM_SELECTION')
  private setDiagramSelection;

  @TriplogModule.Getter('getFuelUnit')
  private fuelUnit: string;

  get entries() {
    return this.diagram[this.attributeSelection];
  }

  get attributeSelection() {
    return this.diagramSelections[this.index];
  }

  get showSmartConnectInfo() {
    return !isNullOrUndefined(this.diagram.ecoScore);
  }

  onChange(e) {
    this.setDiagramSelection({ index: this.index, selection: e.target.value });
  }
}
